var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inner-card", style: { background: _vm.backgroundColor } },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _vm._l(_vm.education, function (item, index) {
                      return [
                        _c(
                          "div",
                          {
                            key: "educationCategory" + index,
                            staticClass: "col-md-6",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required", mode: "lazy" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 學歷 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Educational background"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      filterable: "",
                                                      placeholder: "請選擇",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.changeEducationDegree(
                                                          item
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        item.EducationCategoryGuid,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "EducationCategoryGuid",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item.EducationCategoryGuid",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.educationDegreeOptions,
                                                    function (educationDegree) {
                                                      return _c("el-option", {
                                                        key: educationDegree.Guid,
                                                        attrs: {
                                                          label:
                                                            educationDegree.Name,
                                                          value:
                                                            educationDegree.Guid,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "School" + index,
                            class:
                              item.SchoolGuid ===
                              "11111111-1111-1111-1111-111111111111"
                                ? "col-md-3"
                                : "col-md-6",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 學校名稱 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [_vm._v("School name")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      filterable: "",
                                                      placeholder: "請選擇",
                                                      disabled:
                                                        item.EducationCategoryGuid ===
                                                          _vm.highSchoolGuid ||
                                                        item.EducationCategoryGuid ===
                                                          _vm.secondaryGuid ||
                                                        item.EducationCategoryGuid ===
                                                          _vm.elementarySchoolGuid,
                                                    },
                                                    model: {
                                                      value: item.SchoolGuid,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "SchoolGuid",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item.SchoolGuid",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.schoolOptions,
                                                    function (school) {
                                                      return _c(
                                                        "el-option",
                                                        {
                                                          key: school.Guid,
                                                          attrs: {
                                                            label: school.Name,
                                                            value: school.Guid,
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                "text-overflow":
                                                                  "ellipsis",
                                                                overflow:
                                                                  "hidden",
                                                                "max-width":
                                                                  "calc(100vw - 135px)",
                                                                "white-space":
                                                                  "nowrap",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    school.Name
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        item.SchoolGuid ===
                        "11111111-1111-1111-1111-111111111111"
                          ? _c(
                              "div",
                              {
                                key: "schoolDescription" + index,
                                staticClass: "col-md-3",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "field" },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "field-title",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "mark" },
                                                      [_vm._v("*")]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        style: {
                                                          color: _vm.fontColor,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " 其他學校名稱 "
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "en-text",
                                                          },
                                                          [_vm._v("School")]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "field-value",
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            item.SchoolDescription,
                                                          expression:
                                                            "item.SchoolDescription",
                                                        },
                                                      ],
                                                      attrs: {
                                                        type: "text",
                                                        maxlength: "200",
                                                        autocomplete: "off",
                                                        readonly: "",
                                                      },
                                                      domProps: {
                                                        value:
                                                          item.SchoolDescription,
                                                      },
                                                      on: {
                                                        focus: function (
                                                          $event
                                                        ) {
                                                          return _vm.$common.removeReadonly(
                                                            $event
                                                          )
                                                        },
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            item,
                                                            "SchoolDescription",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                errors[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { key: "major" + index, staticClass: "col-md-6" },
                          [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "field-title" }, [
                                _c(
                                  "span",
                                  { style: { color: _vm.fontColor } },
                                  [
                                    _vm._v(" 科系名稱 "),
                                    _c("span", { staticClass: "en-text" }, [
                                      _vm._v("Course category"),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "field-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.MajorName,
                                      expression: "item.MajorName",
                                    },
                                  ],
                                  attrs: {
                                    type: "text",
                                    maxlength: "50",
                                    autocomplete: "off",
                                    readonly: "",
                                  },
                                  domProps: { value: item.MajorName },
                                  on: {
                                    focus: function ($event) {
                                      return _vm.$common.removeReadonly($event)
                                    },
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        item,
                                        "MajorName",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "isDaySchool" + index,
                            staticClass: "col-md-3",
                          },
                          [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "field-title" }, [
                                _c(
                                  "span",
                                  { style: { color: _vm.fontColor } },
                                  [
                                    _vm._v(" 日校/夜校 "),
                                    _c("span", { staticClass: "en-text" }, [
                                      _vm._v("Day school/Night school"),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "field-radio" }, [
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: item.IsDaySchool,
                                        expression: "item.IsDaySchool",
                                      },
                                    ],
                                    attrs: { type: "radio" },
                                    domProps: {
                                      value: true,
                                      checked: _vm._q(item.IsDaySchool, true),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$set(
                                          item,
                                          "IsDaySchool",
                                          true
                                        )
                                      },
                                    },
                                  }),
                                  _c("span", [_vm._v("日校 (Day school)")]),
                                ]),
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: item.IsDaySchool,
                                        expression: "item.IsDaySchool",
                                      },
                                    ],
                                    attrs: { type: "radio" },
                                    domProps: {
                                      value: false,
                                      checked: _vm._q(item.IsDaySchool, false),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$set(
                                          item,
                                          "IsDaySchool",
                                          false
                                        )
                                      },
                                    },
                                  }),
                                  _c("span", [_vm._v("夜校 (Night school)")]),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "isGraduate" + index,
                            staticClass: "col-md-3",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 是否畢業 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Whether or not graduated"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-radio" },
                                              [
                                                _c("label", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: item.IsGraduate,
                                                        expression:
                                                          "item.IsGraduate",
                                                      },
                                                    ],
                                                    attrs: { type: "radio" },
                                                    domProps: {
                                                      value: true,
                                                      checked: _vm._q(
                                                        item.IsGraduate,
                                                        true
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          item,
                                                          "IsGraduate",
                                                          true
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c("span", [
                                                    _vm._v("是 (Yes)"),
                                                  ]),
                                                ]),
                                                _c("label", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: item.IsGraduate,
                                                        expression:
                                                          "item.IsGraduate",
                                                      },
                                                    ],
                                                    attrs: { type: "radio" },
                                                    domProps: {
                                                      value: false,
                                                      checked: _vm._q(
                                                        item.IsGraduate,
                                                        false
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          item,
                                                          "IsGraduate",
                                                          false
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c("span", [
                                                    _vm._v("否 (No)"),
                                                  ]),
                                                ]),
                                              ]
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "educationFrom" + index,
                            staticClass: "col-md-3",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 入學年月 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Enrollment period (Start)"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("el-date-picker", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    type: "month",
                                                    "value-format": "yyyy-MM",
                                                    placeholder: "YYYY-MM",
                                                  },
                                                  model: {
                                                    value: item.EducationFrom,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "EducationFrom",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.EducationFrom",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "educationTo" + index,
                            staticClass: "col-md-3",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: {
                                    rules: {
                                      notBeforeStartDate: item.EducationFrom,
                                      required: item.IsGraduate ? true : false,
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    item.IsGraduate
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass: "mark",
                                                          },
                                                          [_vm._v("*")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" 離校年月 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Enrollment period (End)"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("el-date-picker", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    type: "month",
                                                    "value-format": "yyyy-MM",
                                                    placeholder: "yyyy-MM",
                                                  },
                                                  model: {
                                                    value: item.EducationTo,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "EducationTo",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.EducationTo",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { key: "button" + index, staticClass: "col-md-6" },
                          [
                            _vm.education.length > 1
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "del-btn",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.del(index)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("BUTTON.RESUME_DELETE")) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    }),
                  ],
                  2
                ),
                _c("div", { staticClass: "edit-btn-wrap" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn-sm add-btn",
                      attrs: { type: "button" },
                      on: { click: _vm.add },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("BUTTON.RESUME_ADD")) + " ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "put-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return handleSubmit(_vm.saveEducation)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("BUTTON.RESUME_SAVE")) + " ")]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }